import React, { useEffect, useState } from "react";
import "./footer.css"
import VolumeIcon from "./FooterImages/volume";
import ContactIcon from "./FooterImages/contactDetails"
import LegalProvison from "./FooterImages/legalProvison";
import { CONTACT_DIRECTORY, ECI_GOV_URL, ECINET_URL } from "../../constants/constants";

const FOOTER= {
    "FOOTER_UPDATES": "ECI Updates",
    "FOOTER_CONACT": "Contact Directory",
    "LEGAL_PROVISION": "Legal Provision",
    "FOOTER_COPY": "© Copyright Election Commission of India 2026.",
    "FOOTER_TERMS": "Terms & Conditions",
    "FOOTER_PRIVACY": "Privacy Policy",
    "FOOTER_POLICY": "Cookie Policy"
  }

function Footer() {
    const [isSession, setIsSession] = useState(false);

    useEffect(() => {

        if (localStorage.hasOwnProperty("access_token")) {
            setIsSession(true);
        }
    }, []);

    return (
        <div className="footerCenter">
            <div className="mainFooter">
                <a href={ECINET_URL + "/home/eciUpdates"} target="_blank" className="updates upperFooterText">
                    <span className="marginFooterImage">{<VolumeIcon />}</span>
                    {FOOTER?.FOOTER_UPDATES}
                </a>
                {isSession &&
                    <a href='#' className="contact upperFooterText">
                        <span className="marginFooterImage">{<LegalProvison />}</span>
                        {FOOTER?.LEGAL_PROVISION}
                    </a>
                }
                <a href={ECI_GOV_URL + "/officers-directory"} target="_blank" className="contact upperFooterText">
                    <span className="marginFooterImage">{<ContactIcon />}</span>
                    {FOOTER?.FOOTER_CONACT}
                </a>
            </div>

            <div className="textParent">
                <div className="myText2">{FOOTER?.FOOTER_COPY}</div>&nbsp;|&nbsp;
              {/* <a href="#" className="myText"><div>{FOOTER?.FOOTER_TERMS}</div></a>&nbsp;|&nbsp; */}
                <a href={"https://www.eci.gov.in/website-policy/privacy-policy-r5/"} target="_blank" className="myText"><div>{FOOTER?.FOOTER_PRIVACY}</div></a>
                {/* <a href="#" className="myText"><div>{FOOTER?.FOOTER_POLICY}</div></a> */}
            </div>
        </div>
    )
}

export default Footer;